<section class="mainTopBanner section-pd">
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div class="topBannerWrapper">
                    <div class="top-banner-left">
                        <h1 class="trinka-sub-title">個人詞典</h1>
                        <h2>專屬你的個人詞典，Trinka 智慧加持。</h2>
                        <p>將 Trinka 不認識的新詞加入個人詞典，像是品牌名稱或新技術，避免拼字建議提醒。</p>
                        <div class="btn-group">
                            <a href="https://cloud.trinka.ai/signup?_rg=TW" class="filled-btn" target="_blank">開始使用</a>
                        </div>
                    </div>
                    <div class="top-banner-right">
                        <img src="/assets/images/features/personal-dictionary/Personal-Dictionary.webp" width="492" height="360" alt="personal dictionary in trinka" priority />
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="howItWorks section-pd list-wrapper-style-2">
    <div class="trinka_container container">
        <div class="row align-items-center">
            <div class="col-lg-6">
                <div class="list-wrapper-image">
                    <a href="" data-toggle="modal" data-target="#youtubeModalPopup" id="VewiVideoSection">
                        <img src="/assets/images/yt-thumbnail/MyDicitonayThumbnail.webp" width="1280" height="720" alt="personal dictionary" class="img-fluid eposter-img">
                    </a>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="list-wrapper-content-2">
                    <div class="trinka-title mb-0">
                        <h2>觀看教學</h2>
                        <div class="HeadingSubLine1"><span></span><span></span><span></span></div>
                        <p>立即觀看操作教學影片，快速上手「個人詞典」功能！</p>
                        <p>透過簡單的教學影片，讓你一步步學會如何使用 Trinka。</p>
                        <p>還有其他問題嗎？歡迎瀏覽我們的常見問答</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="section-pd pb-0">
    <div class="trinka_container container">
        <div class="row">
            <div class="col-sm-12">
                <div class="trinka-title mb-0 text-center">
                    <h2>個人詞典主要特點</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                    <p>擺脫不必要的拼字建議提醒，讓您的寫作體驗更順暢無阻。</p>
                </div>
            </div>
        </div>
    </div>

    <section class="section-pd list-wrapper-style-2">
        <div class="trinka_container container">
            <div class="row align-items-center flex-row-reverse">
                <div class="col-md-6">
                    <div class="list-wrapper-content-2">
                        <h3>詞彙分類管理</h3>
                        <p>您可以將加入個人詞典的詞彙分類為正確拼字、技術術語、生物學名稱、產品名稱等，隨著您的使用，Trinka 會變得越來越聰明。</p>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="list-wrapper-image">
                        <img src="/assets/images/features/personal-dictionary/correct-spelling.webp" width="426" height="277" alt="Categorization of Words" class="img-fluid md50">
                    </div>
                </div>
            </div>
        </div>
    </section>

    <section class="list-wrapper-style-2 pt-0">
        <div class="trinka_container container">
            <div class="row align-items-center">
                <div class="col-md-6">
                    <div class="list-wrapper-content-2 pr-80">
                        <h3>調整大小寫敏感度</h3>
                        <p>您可設定 Trinka 是否在大小寫符合時忽略詞典中的詞彙，或不論大小寫皆忽略。</p>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="list-wrapper-image features-img">
                        <img src="/assets/images/features/personal-dictionary/case-sensitive.webp" width="426" height="277" alt="adjust case sensitive" class="img-fluid">
                    </div>
                </div>
            </div>
        </div>
    </section>

    <section class="section-pd list-wrapper-style-2">
        <div class="trinka_container container">
            <div class="row align-items-center flex-row-reverse">
                <div class="col-md-6">
                    <div class="list-wrapper-content-2">
                        <h3>選擇英文類型</h3>
                        <p>Trinka 允許您控制是否僅在英文類型（如美式英語或英式英語）匹配時忽略新增詞彙，或不論英文類型皆忽略。
                        </p>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="list-wrapper-image">
                        <img src="/assets/images/features/personal-dictionary/american-english.webp" width="426" height="277" alt="Choose English Type" class="img-fluid">
                    </div>
                </div>
            </div>
        </div>
    </section>

    <section class="list-wrapper-style-2 pt-0">
        <div class="trinka_container container">
            <div class="row align-items-center">
                <div class="col-md-6">
                    <div class="list-wrapper-content-2 pr-80">
                        <h3>跨平台同步</h3>
                        <p>Trinka 的詞典會即時同步至所有平台，無論是在雲端編輯器、MS Word 外掛或瀏覽器擴充功能中，都能無縫使用。</p>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="list-wrapper-image features-img">
                        <img src="/assets/images/features/personal-dictionary/SyncAcrossPlatforms.webp" width="300" height="248" alt="Sync Across Platforms" class="img-fluid" style="max-width: 300px;" />
                    </div>
                </div>
            </div>
        </div>
    </section>

    <section class="section-pd list-wrapper-style-2">
        <div class="trinka_container container">
            <div class="row align-items-center flex-row-reverse">
                <div class="col-md-6">
                    <div class="list-wrapper-content-2">
                        <h3>維持企業品牌語調</h3>
                        <p>將您的組織專用詞彙和新詞加入詞典，確保所有溝通內容維持品牌風格，並個人化您的寫作輔助工具。</p>    
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="list-wrapper-image">
                        <img src="/assets/images/features/personal-dictionary/MyDictionary_Brand-tone.webp" width="320" height="320" alt="maintain brand tone" class="img-fluid" style="max-width: 300px;" />
                    </div>
                </div>
            </div>
        </div>
    </section>
</section>

<section class="trinka-banner section-pd-sm">
    <div class="trinka_container container">
        <div class="row justify-content-center">
            <div class="col-md-12 col-lg-12">
                <div class="trinka-title text-center">
                    <h3 class="text-white">用專屬詞典打造個人化寫作體驗</h3>
                </div>
                <div class="btn-group justify-content-center">
                    <a href="https://cloud.trinka.ai/signup?_rg=TW" class="white-btn" target="_blank">開始使用</a>
                </div>
            </div>
        </div>  
    </div>
</section>

<app-security-section></app-security-section>

<section class="faqQuestionAnwser section-pd pt-0" #target>
    <div class="trinka_container container">
        <div class="row justify-content-center">
            <div class="col-lg-8 col-md-10">
                <div class="trinka-title text-center">
                    <h2>常見問答</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                </div>
            </div>
        </div>
        <div class="faqQuestionsList">
            <div class="accordion" id="faq">
                <div class="row">
                    <div class="col-lg-6">
                        <div class="faqContainer">
                            <div class="card">
                                <div class="card-header" id="QuestionOne">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionOneContent" aria-expanded="true" aria-controls="QuestionOneContent">
                                        我加入的詞彙，其他用戶看得到嗎？ </a>
                                </div>

                                <div id="QuestionOneContent" class="collapse" aria-labelledby="QuestionOne" data-parent="#faq">
                                    <div class="card-body">
                                        <p>您的個人詞典只有您自己能存取和使用，其他人無法查看或使用其中的內容。</p>
                                    </div>
                                </div>
                            </div>
                            <div class="card">
                                <div class="card-header" id="QuestionTwo">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionTwoContent" aria-expanded="true"
                                        aria-controls="QuestionTwoContent">我在哪裡可以找到我的個人詞典？ </a>
                                </div>

                                <div id="QuestionTwoContent" class="collapse" aria-labelledby="QuestionTwo" data-parent="#faq">
                                    <div class="card-body">
                                        <p>請至「帳戶設定」中的「寫作設定」區塊，點選「我的詞典」按鈕即可查</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="faqContainer">
                            <div class="card">
                                <div class="card-header" id="QuestionThree">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionThreeContent" aria-expanded="true"
                                        aria-controls="QuestionThreeContent">
                                        我可以與其他帳號分享我的詞典嗎？
                                    </a>
                                </div>

                                <div id="QuestionThreeContent" class="collapse" aria-labelledby="QuestionThree" data-parent="#faq">
                                    <div class="card-body">
                                        <p>您的詞典是專屬個人使用，無法與其他帳號分享。</p>
                                    </div>
                                </div>
                            </div>
                            <div class="card">
                                <div class="card-header" id="QuestionFour">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionFourContent" aria-expanded="true"
                                        aria-controls="QuestionFourContent">
                                        我可以下載我的個人詞典嗎？
                                    </a>
                                </div>

                                <div id="QuestionFourContent" class="collapse" aria-labelledby="QuestionFour" data-parent="#faq">
                                    <div class="card-body">
                                        <p>目前尚無下載功能，但我們會在未來版本加入此項功能，敬請期待。</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<app-trinka-in-other-apps></app-trinka-in-other-apps>

<div class="modal" id="youtubeModalPopup">
    <div class="modal-dialog modal-dialog-centered modal-lg">
       <div class="modal-content">
          <div class="modal-body no-padding">
             <button type="button" class="btn-close" data-dismiss="modal" (click)="stopAllVideos()"></button>
             <iframe class="youtubeVideoForTryDemo" id="iframe" width="100%" height="450" src="https://www.youtube.com/embed/5KsBh4PQUPI"
                title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen></iframe>
          </div>
       </div>
    </div>
</div>